  export default function Example() {
    return (
      <div className="px-4 sm:px-6 lg:px-8">
      </div>
    )
  }
  